import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonItem, IonList, IonSelect, IonSelectOption } from '@ionic/angular/standalone';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { Store } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-puzzle-changer-form',
  templateUrl: './puzzle-changer-form.component.html',
  styleUrls: ['./puzzle-changer-form.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, IonItem, IonList, IonSelect, IonSelectOption],
})
export class PuzzleChangerFormComponent {
  languages: {
    name: string;
    slug: string;
    label: string;
  }[];

  languageIndex: number;
  difficultyParameterEnabled: boolean;
  urlDifficultyParameterInPuzzleParameter: boolean;
  difficultyChangerInForm: boolean;
  languageParameterEnabled: boolean;
  selectedLanguage: string;

  difficulties: string[];
  selectedDifficulty: string;
  currentDifficulty: string;

  readonly popoverOptions = { showBackdrop: false, cssClass: 'puzzle-changer-popover' };

  dirty = false;

  @Input() hideApplyButton = false;
  @Input() displayLanguagePicker = true;
  @Output() applyCallback = new EventEmitter<() => void>();

  constructor(private store: Store, private framework: PuzzleFrameworkService) {
    this.store
      .select((state) => state.puzzleFrameworkConfig.languagePickerValues)
      .subscribe((languages) => {
        this.languages = languages;
        this.updateLanguageSelector();
      });
    this.store
      .select((state) => state.puzzleFrameworkConfig.difficultyValues)
      .subscribe((difficulties) => {
        this.difficulties = difficulties;
      });
    this.store
      .select((state) => state.puzzleFrameworkConfig.urlDifficultyParameterEnabled)
      .subscribe((enabled) => {
        this.difficultyParameterEnabled = !!enabled;
      });
    this.store
      .select((state) => state.puzzleFrameworkConfig.urlDifficultyParameterInPuzzleParameter)
      .subscribe((enabled) => {
        this.urlDifficultyParameterInPuzzleParameter = !!enabled;
      });
    this.store
      .select((state) => state.puzzleFrameworkConfig.difficultyChangerInFormEnabled)
      .subscribe((enabled) => {
        this.difficultyChangerInForm = !!enabled;
      });
    this.store
      .select((state) => state.puzzleFrameworkConfig.urlLanguageParameterEnabled)
      .subscribe((enabled) => {
        this.languageParameterEnabled = !!enabled;
      });
    this.store
      .select((state) => state.puzzleGameState.language)
      .subscribe((language) => {
        this.selectedLanguage = language;
        this.updateLanguageSelector();
      });
    this.store
      .select((state) => state.puzzleGameState.difficulty)
      .subscribe((difficulty) => {
        this.selectedDifficulty = difficulty;
        this.currentDifficulty = difficulty;
      });
  }

  checkApplyButton() {
    if (
      this.selectedLanguage !== this.languages[this.languageIndex].name ||
      this.selectedDifficulty !== this.currentDifficulty
    ) {
      this.dirty = true;
      this.applyCallback.emit(() => {
        this.apply();
      });
    } else {
      this.applyCallback.emit(undefined);
      this.dirty = false;
    }
  }

  difficultyChanged() {
    if (this.languages && this.languages.length && this.languageParameterEnabled) {
      this.checkApplyButton();
      // return;
    }

    const hashParameters = this.framework.getHashParameters();

    // This is a duplicate of puzzle-button-bar-component.ts.openDifficultyPicker()
    // If we have the difficulty in the puzzle parameter, we need to chang it.
    if (this.urlDifficultyParameterInPuzzleParameter) {
      // Remove any difficulty parameter from the puzzle parameter.
      for (const difficulty of this.framework.puzzleFrameworkConfig.difficultyValues) {
        hashParameters.puzzle = hashParameters.puzzle.replace(`-${difficulty}`, '');
      }
      // Now set the new one.
      hashParameters.puzzle = `${hashParameters.puzzle}-${this.selectedDifficulty}`;
    } else {
      // Otherwise we change the difficulty parameter.
      hashParameters.difficulty = this.selectedDifficulty;
    }

    window.location.hash =
      '#' +
      Object.keys(hashParameters)
        .map((key) => key + '=' + hashParameters[key])
        .join('&');
  }

  languageChanged() {
    if (this.difficulties && this.difficulties.length && this.difficultyParameterEnabled) {
      this.checkApplyButton();
      // return;
    }
    const hashParameters = this.framework.getHashParameters();
    hashParameters.language = this.languages[this.languageIndex].name;
    window.location.hash =
      '#' +
      Object.keys(hashParameters)
        .map((key) => key + '=' + hashParameters[key])
        .join('&');
  }

  private updateLanguageSelector() {
    if (!(this.languages && this.languages.length && this.selectedLanguage)) {
      return;
    }
    this.languageIndex = this.languages.map((language) => language.name).indexOf(this.selectedLanguage);
  }

  apply() {
    const hashParameters = this.framework.getHashParameters();
    hashParameters.language = this.languages[this.languageIndex].name;
    hashParameters.difficulty = this.selectedDifficulty;
    window.location.hash =
      '#' +
      Object.keys(hashParameters)
        .map((key) => key + '=' + hashParameters[key])
        .join('&');
    window.location.reload();
  }
}
